import client from './client';
import { EnCryptData, DeCryptData } from '../util/CustomUtil';

// export const listEsRequest = id => client.get(`/esrequest/list/${id}`);

// 견적서 리스트 요청 
export const listEsRequest = ({ param }) => {
    return client.get('/es?' + param);
}

// 견적서 삭제 요청 
export const delEsRequest = ({ param }) => {
    return client.get('/es/del?reqid=' + param);
}

export const postEsApplyRequest = ({ token, info, prods }) => {
    let params = new URLSearchParams();
    params.append('accessToken', EnCryptData(token));
    params.append('info', EnCryptData(JSON.stringify(info)));
    params.append('prods', EnCryptData(JSON.stringify(prods)))
    return client.post('/es/apply', params);
}

export const postEsApplyMultiRequest = ({ token, info, prods }) => {
    let params = new URLSearchParams();
    params.append('accessToken', EnCryptData(token));
    params.append('info', EnCryptData(JSON.stringify(info)));
    params.append('prods', EnCryptData(JSON.stringify(prods)))
    return client.post('/es/multiapply', params);
}

export const getEsInfo = ({ param }) => {
    return client.get('/es/info' + param);
}

export const getEsDetailInfo = ({ param }) => {
    return client.get('/es/detail?reqid=' + param);
}

// 주문 
export const orderEs = ({ es_id, revname, mobile1, mobile2, reqdlrv, payinfo }) => {
    let paramdata = { es_id, revname, mobile1, mobile2, reqdlrv, payinfo };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/es/order', params);
}

// 주문 상세 
export const getOrderInfo = ({ param }) => {
    return client.get('/es/order' + param);
}

export const getEsInfoView = ({ param }) => {
    return client.get('/es/infoview' + param);
}

export const postUpdateEsStatus = ({ es_rqst_id, status }) => {
    let params = new URLSearchParams();
    params.append('reqid', es_rqst_id);
    params.append('status', status)
    return client.post('/es/updatestatus', params);
}

//견적 진행중 카운트 포함되는 것
export const getListEsIng = () => {
    return client.get('/es/ing');
}

//견적 주문 완료
export const getListEsDone = ({ offset = 0 }) => {
    return client.get('/es/done?offset=' + offset);
}

//견적 진행중 카운트 포함 안되는 것. (취소, 불가, 만료)
export const getListEsBefore = ({ offset = 0 }) => {
    let urlString = "/es/before?offset=" + offset;
    return client.get(urlString);
}

// 견적서 삭제 요청 
export const delEsBeforeRequest = ({ param }) => {
    return client.get('/es/delbefore?reqid=' + param);
}

// 주문 
export const orderMultiEs = ({ es_id, revname, mobile1, mobile2, reqdlrv,count, payinfo }) => {
    let paramdata = { es_id, revname, mobile1, mobile2, reqdlrv,count, payinfo };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/es/multiorder', params);
}

export const getMultiEsInfo = ({ param }) => {
    return client.get('/es/multiinfo' + param);
}

export const getListEsStatus = () => {
    return client.get('/es/status');
}

// 브랜드 가져오기 
export const getBrandMyEsStep1 = ({ cateItems }) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cateItems);
    return client.post('/brand/mystep1', params);
}

//모든 브랜드의 카테고리 2이름 가져오기
export const getBrandMyEsCate2Name = () => {
    return client.post('/brand/cate2brandmystep3');
}

// 브랜드와 브랜드 상품 가져오기 
export const getBrandMyEsStep3 = ({ cateItems, offset = 0 }) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cateItems);
    params.append('offset', offset);
    return client.post('/brand/mystep3', params);
}